module.exports = __webpack_public_path__ + "img/icon_map_37_off_010.d1a86c94.png";